import { useState } from 'react';
import { proofThumbnail } from '../reviewPortal/reviewLens';

/**
 * One piece of approved artwork, on a document.
 *
 * A Drive share URL is a VIEWER PAGE, not an image. Dropping it into an <img>
 * renders a broken icon — reviewLens.ts says exactly that, and the client
 * review portal has converted it to Drive's thumbnail endpoint since the day
 * that page was built. The certificate, the frozen PO and the factory's job
 * order were all written later, all took the same `{ component, version, url }`
 * payload, and all three put the URL straight into an <img>.
 *
 * So a factory opened the artwork they were told to build to and saw four
 * broken icons, and the certificate printed the same. Same fix as the review
 * portal, in one place this time.
 *
 * A thumbnail that still fails falls back to a link. Better a line of text
 * that opens the file than a broken-image box on a document that exists to
 * prove what was approved.
 */
export function ProofImage({ url, alt }: { url: string; alt: string }) {
  const src = proofThumbnail(url);
  const [failed, setFailed] = useState(false);

  if (src === null || failed) {
    return (
      <a className="po-doc-proof-link" href={url} target="_blank" rel="noopener noreferrer">
        Open {alt} ↗
      </a>
    );
  }
  return <img src={src} alt={alt} loading="lazy" onError={() => setFailed(true)} />;
}
